<!--
 * @Description: 批量上传水印选择
 * @Author: dengnanhao
 * @Date: 2021-05-06 15:46:17
 * @LastEditors: dengnanhao
 * @LastEditTime: 2021-06-25 17:55:57
-->
<template>
  <div class="watermark-select__wrapper">
    <el-dialog
      title="选择水印类型"
      width="700px"
      top="-40vh"
      custom-class="watermark-upload-dialog"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="showDialog = false"
    >
      <el-radio-group v-model="radio" size="mini">
        <el-radio
          v-for="item in watermarktypes"
          :key="item.id"
          :label="item.id"
          border
        >
          <img :src="item.img" alt="">
          <el-tooltip :disabled="item.id!==4" class="item" effect="light" :content="item.name" placement="bottom">
            <span class="itemName">{{item.name}}</span>
          </el-tooltip>
        </el-radio>
      </el-radio-group>
      <el-divider></el-divider>
      <div class="footer-btns-wrap">
        <el-button type="primary" @click.native="handleSubmit">
          继续
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'WatermarkSelect',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDialog: false,
      radio: 1,
      watermarktypes: []
    };
  },
  watch: {
    value(val, oldValue) {
      this.showDialog = val
    },
    showDialog(val, oldValue) {
      this.$emit('input', val)
    }
  },
  mounted() {
    this.getWaterMark()
  },
  methods: {
    ...mapActions({
      getWaterMarkTypes: 'forensic/getWaterMarkTypes'
    }),
    handleSubmit() {
      this.$store.commit('forensic/setBatchUploadWatermarkType', this.radio)
      this.showDialog = false
      this.$emit('handleSubmit', true)
    },
    getWaterMark() {
      this.getWaterMarkTypes().then(res => {
        const wm = res.data.data
        wm.forEach(el => {
          if (el.id == 1) {
            el.img = require('../../../assets/imgs/u291.png')
          }
          if (el.id == 2) {
            el.img = require('../../../assets/imgs/u298.png')
          }
          if (el.id == 3) {
            el.img = require('../../../assets/imgs/u288.png')
          }
          if (el.id == 4) {
            el.img = require('../../../assets/imgs/u317.png')
          }
          if (el.id == 5) {
            el.img = require('../../../assets/imgs/u311.png')
          }
          if (el.id == 6) {
            el.img = require('../../../assets/imgs/u309.png')
          }
          if (el.id == 7) {
            el.img = require('../../../assets/imgs/u310.png')
          }
          if (el.id == 8) {
            el.img = require('../../../assets/imgs/u312.png')
          }
        })
        this.watermarktypes = wm
      })
    }
  }
}
</script>

<style lang="scss">
    .watermark-select__wrapper {
        .el-dialog {
            .el-dialog__body{
               padding-left: 40px!important;
               padding-top: 40px;
                .el-radio-group {
                    margin-bottom: 10px;
                    margin-left: 7px;
                    .el-radio {
                        padding-top: 15px;
                        position: relative;
                        width: 140px;
                        height: 140px;
                        margin-bottom: 20px;
                        margin-left: 0;
                        margin-right: 15px;
                        img{
                            height: 70px;
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 2px;
                            object-fit: contain;
                        }
                        .itemName {
                          display: block;
                          margin-left: 35px;
                          font-size: 13px;
                          overflow : hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        }
                        .el-radio__input {
                            position: absolute;
                            bottom: 16px;
                            left: 20px;
                            .el-radio__inner {
                                width: 15px;
                                height: 15px;
                            }
                        }
                        .el-radio__label {
                            // display: flex;
                            line-height: 50px;
                            font-size: 14px;
                            padding-left: 0;
                        }
                    }
                }

            }
            .el-divider {
              margin-top: 15px;
            }
            .footer-btns-wrap {
              height: 40px;
              position: relative;
              .el-button {
                position: absolute;
                right: 26px;
                width: 100px;
              }
            }

        }
    }
</style>
